<!-- <div class="row bloccodati"> -->
  <!-- <div labelTextInput class="col-sm-4" [typeLabel]="'text'" [labelInput]="'Tipo richiedente'"
    [valueInput]="ctxBodyFascicolo.fascicolo.tipoRichiedente ? 'Interno' : 'Esterno'"></div> -->
  <!-- <div labelTextInput class="col-sm-3" [typeLabel]="'text'"
       [labelInput]="'Oggetto'" [valueInput]="ctxBodyFascicolo.fascicolo.oggetto"></div>
  <div labelTextInput class="col-sm-3" [typeLabel]="'text'"
       [labelInput]="'Società'" [valueInput]="ctxBodyFascicolo.fascicolo.societa?.nome"></div> -->
<!-- </div> -->
<div class="row bloccodati">
  <div labelTextInput class="col-sm-4" [typeLabel]="'text'"
        [labelInput]="'Tipologia'"
        [valueInput]="ctxBodyFascicolo.fascicolo.tipologiaGenericoConsulenza ? ctxBodyFascicolo.fascicolo.tipologiaGenericoConsulenza.label : ''"></div>
</div>

<!-- <div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label for="quesito_richiesta" class="col-sm-12">Descrizione oggetto</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.richiesta }}</span>
    </p>
  </div>
</div> -->

<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>